import { render, staticRenderFns } from "./dataClear.vue?vue&type=template&id=34f5eb74&"
import script from "./dataClear.vue?vue&type=script&lang=js&"
export * from "./dataClear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports